<template>

  <!--联系我们-->
  <div>
    <ShortCut></ShortCut>
    <LogoHome></LogoHome>
    <Navigation></Navigation>
    <div class="content-class">
    <div class="left-content-class">
      <img src="../image/contact-img.png" align="left" width="500" hspace="5" vspace="5" class="img-left-content-class">
    </div>
    <div class="right-content-class">
      <span class="left-font-class">
        公司：
      </span>
      <span class="right-font-class">
        山东康成尔兴药业集团有限公司
      </span>
      <br/>
      <span class="left-font-class">
      </span>
      <span class="right-font-class">
        山东康成尔兴药业集团有限公司
      </span>
      <br/>
      <span class="left-font-class">
        地址：
      </span>
      <span class="right-font-class">
        山东省淄博市人民西路616号
      </span>
      <br/>
      <span class="left-font-class">
        电话：
      </span>
      <span class="right-font-class">
        0533-6588912&nbsp&nbsp&nbsp&nbsp邮编：255000
      </span>
      <br/>
      <span class="left-font-class">
        质量管部：
      </span>
      <span class="right-font-class">
        6588913、6588915
      </span>
      <br/>
      <span class="left-font-class">
        信 息 部：
      </span>
      <span class="right-font-class">
        6588910
      </span>
      <br/>
      <span class="left-font-class">
        财 务 部：
      </span>
      <span class="right-font-class">
        6588900、6588911、6588922、
      </span>
      <br/>
      <span class="left-font-class">

      </span>
      <span class="right-font-class">
        6588933
      </span>
      <br/>
      <span class="left-font-class">
        采 购 部：
      </span>
      <span class="right-font-class">
         6588926、6588927、6588928、
      </span>
      <br/>
      <span class="left-font-class">

      </span>
      <span class="right-font-class">
         6588929
      </span>
      <br/>
      <span class="left-font-class">
        业 务 部：
      </span>
      <span class="right-font-class">
        6588905、6588906、6588907、
      </span>
      <br/>
      <span class="left-font-class">

      </span>
      <span class="right-font-class">
        6588908、6588909
      </span>
      <br/>
      <span class="left-font-class">
        销 售 部：
      </span>
      <span class="right-font-class">
        6588930
      </span>
      <br/>
      <span class="left-font-class">
        储 运 部：
      </span>
      <span class="right-font-class">
        6588932
      </span>
      <br/>
      <span class="left-font-class">
        入库室：
      </span>
      <span class="right-font-class">
        6588903
      </span>
      <br/>
      <span class="left-font-class">
        出单室：
      </span>
      <span class="right-font-class">
        6588923
      </span>
      <br/>
      <span class="left-font-class">
        仓库收货：
      </span>
      <span class="right-font-class">
        6588931
      </span>
      <br/>
      <span class="left-font-class">
        门卫室：
      </span>
      <span class="right-font-class">
        6588925
      </span>
      <br/>
      <span class="left-font-class">
        仓库经理：
      </span>
      <span class="right-font-class">
        6588921
      </span>
      <br/>
      <span class="left-font-class">
        订货电话：
      </span>
      <span class="right-font-class">
        6588916  （17、18、19、20）
      </span>
    </div>
<!--    <div>-->
<!--      <br class="br-content-class"/>-->
<!--      <div class="left-font-class">-->
<!--        公司：-->
<!--      </div>-->
<!--      <div class="right-font-class">-->
<!--        山东康成尔兴药业集团有限公司-->
<!--      </div>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          公司：-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            山东康成尔兴药业集团有限公司-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          &nbsp&nbsp&nbsp&nbsp-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            山东康为医药有限公司-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          地址：-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            山东省淄博市人民西路616号-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          电话：-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            0533-6588912&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp邮编：255000-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          质量管部：-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            6588913、6588915-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          信 息 部：-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            6588910-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          财 务 部：-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            6588900、6588911、6588922、6588933-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          采 购 部：-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            6588926、6588927、6588928、6588929-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          业 务 部：-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            6588905、6588906、6588907 、6588908、 6588909-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          销 售 部：-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            6588930-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          储 运 部：-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            6588932-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          入 库 室：-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            6588903-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          出 单 室：-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            6588923-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          仓库收货：-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            6588931-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          门 卫 室：-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            6588925-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          仓库经理：-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            6588921-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4"><div class="grid-content bg-purple right-font-class">-->
<!--          订货电话：-->
<!--        </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="grid-content bg-purple left-font-class">-->
<!--            6588916 （17、18、19、20）-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--    </div>-->
    </div>
  </div>
</template>

<script>
import ShortCut from '../component/ShortCut'
import Navigation from "../component/Navigation";
import LogoHome from "../component/LogoHome";
export default {
  name: "Contact"
  ,
  components: {
    ShortCut,
    LogoHome,
    Navigation
  },
  data() {
    return {}
  },
  methods: {},
  mounted() {

  }
}
</script>

<style scoped>
.content-class{
  margin-left: 10%;
  margin-top: 2%;
  font-family: cursive;
  font-size: 20px;
  display: flex;
  width: 70%;
}
.right-font-class{
  all:initial;
  display: inline-block;
  /*width: 500px;*/
  text-align: left;
  font-family: cursive;
  font-size: 20px;
}
.left-font-class{
  all:initial;
  display: inline-block;
  width: 200px;
  text-align: right;
  font-family: cursive;
  font-size: 20px;
}

.left-content-class{
  all:initial;
  float: left;
  font-family: cursive;
  font-size: 20px;
}
.right-content-class{
  all:initial;
  float: right;
  width: 500px;
  font-family: cursive;
  font-size: 20px;
  /*display: flex;*/
}
.img-left-content-class{
  margin-top: 20%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Contact.vue